/* eslint-disable react/button-has-type -- This gets applied via getButtonProps */
import type { ReactNode, Ref } from 'react';
import { forwardRef } from 'react';
import type { GetButtonProps } from './Base';
import ButtonBase from './Base';
import type { IconClassName } from '../Icon';
import Icon from '../Icon';
import Tooltip from '../Tooltip';
import type { TooltipButtonProps } from './TooltipButton';

type IconButtonProps = Omit<TooltipButtonProps, 'size' | 'children' | 'type' | 'tooltip'> & {
  /**
   * Icon to display inside the button
   */
  icon: IconClassName; //  Ensure icon is non-optional, as it would be in ButtonProps.
  /**
   * Optional tooltip to display on hover of the button
   */
  tooltip?: ReactNode;
};

/**
 * Generic Icon button component. Used for things like close buttons in the modal.
 */
const IconButton =
  forwardRef<HTMLButtonElement, IconButtonProps>((props: IconButtonProps, ref?: Ref<HTMLButtonElement>) => (
    <ButtonBase
      testId={props.testId}
      isDisabled={props.isDisabled}
      onClick={props.onClick}
    >
      {(getButtonProps: GetButtonProps) => (
        <Tooltip
          tooltip={props.tooltip}
          placement={props.placement}
          showTooltip={props.showTooltip}
      >
          <span className="inline-block">
            <button
            // We want to inject a large number of unknown props here, so spreading is necessary.
            // eslint-disable-next-line react/jsx-props-no-spreading
              {...getButtonProps({
                className: 'fossa-icon-button',
              })}
              ref={ref}
          >
              <Icon icon={props.icon} />
            </button>
          </span>
        </Tooltip>
      )}
    </ButtonBase>
  ));

export default IconButton;
